import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Auth from "./pages/Auth";
import BookDetail from "./pages/BookDetail";
import PublishBook from "./pages/PublishBook";
import Dashboard from "./pages/Dashboard";
import ProposalDetail from "./pages/ProposalDetail";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Wishlist from "./pages/Wishlist";
import MapPage from "./pages/MapPage";
import PublicProfile from "./pages/PublicProfile";
import Bacheca from "./pages/Bacheca";
import Locandina from "./pages/Locandina";
import Avvisi from "./pages/Avvisi";
import Dona from "./pages/Dona";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import BottomNav from "./components/BottomNav";

function Protected({ children, adminOnly }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Caricamento…</div>;
  if (!user) return <Navigate to="/accedi" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  return (
    <>
      <Navbar />
      <div className="pb-20 md:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/accedi" element={<Auth />} />
          <Route path="/libro/:id" element={<BookDetail />} />
          <Route path="/mappa" element={<MapPage />} />
          <Route path="/utente/:id" element={<PublicProfile />} />
          <Route path="/bacheca" element={<Bacheca />} />
          <Route path="/locandina" element={<Locandina />} />
          <Route path="/avvisi" element={<Protected><Avvisi /></Protected>} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie" element={<CookiePolicy />} />
          <Route path="/dona" element={<Dona />} />
          <Route path="/desideri" element={<Protected><Wishlist /></Protected>} />
          <Route path="/pubblica" element={<Protected><PublishBook /></Protected>} />
          <Route path="/modifica/:id" element={<Protected><PublishBook /></Protected>} />
          <Route path="/area-personale" element={<Protected><Dashboard /></Protected>} />
          <Route path="/proposta/:id" element={<Protected><ProposalDetail /></Protected>} />
          <Route path="/profilo" element={<Protected><Profile /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
      <BottomNav />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
